<!-- модалка смены СТАТУСА на 2 (ВЫИГРАЛ) -->
<template>
  <div class="t-lk-modal__content t-lk-win-lead-modal">
      <h2 class="t-lk-modal__title">Смена статуса</h2>

      <form class="t-lk-win-lead-modal__form">
        <vue-recaptcha
          ref="recaptcha"
          size="invisible"
          :sitekey="$root.sitekeyRecaptcha"
          :load-recaptcha-script="true"
          @verify="onCapchaRegister"
          @expired="onCaptchaExpired"
          @error="errorCaptcha"
        />

        <div class="t-lk-win-lead-modal__field">
          <lk-lead-date-cmp
            class="t-lk-win-lead-modal__date"
            :item="props.item"
            @change:date="handleChangeDate"
            UNSAFE_disabledInput
          />

          <input
            class="t-lk-win-lead-modal__input t-input"
            :class="{
              _error: !form.date.valid,
              _valid: form.date.valid
            }"
            :value="formatedDate"
            placeholder="Укажите планируемую дату сделки"
            readonly
          />
        </div>

        <div class="t-lk-win-lead-modal__field">
          <span class="t-lk-win-lead-modal__field-icon">₽</span>
          <input
            :value="form.amount.value"
            @input="handleChangeAmount"
            class="t-input t-lk-win-lead-modal__input"
            :class="{
              _error: !form.amount.valid,
              _valid: form.amount.valid
            }"
            type="tel"
            placeholder="Укажите сумму сделки"
          />
        </div>

        <div class="t-lk-win-lead-modal__field">
          <input
            :value="form.invoiceNumber.value"
            @focusin="handleChangeInvoiceNumber"
            @focusout="focusoutInvoiceNumber"
            @input="handleChangeInvoiceNumber"
            class="t-input t-lk-win-lead-modal__input"
            :class="{
              _error: !form.invoiceNumber.valid,
              _valid: form.invoiceNumber.valid
            }"
            type="text"
            placeholder="Укажите номер счета Axoft"
          />
        </div>
        <p>Обратите внимание, баллы к репутации за выигранную сделку будут начислены только в случае заполнения поля с номером счета</p>

        <div class="t-lk-win-lead-modal__controls">
          <button
            class="t-btn _green _lk"
            @click="handleSubmitClick"  
          >
            Изменить статус
          </button>

          <button
            class="t-btn _border-gray _lk"
            @click="handleRefuseClick"
          >
            Отмена
          </button>
        </div>
      </form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Vue from "vue";
import lkLeadDate from '@components/lk/lk-date-lead/lk-date-lead.vue';
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "win-lead-modal",
  props: ['props'],
  components: {
    VueRecaptcha,
    'lk-lead-date-cmp': lkLeadDate,
  },
  data() {
    return {
      invoiceFieldPrefix: 'Ax',
      form: {
        amount: {
          value: undefined,
          valid: true,
        },
        date: {
          value: this.props.item.dealDate,
          valid: true,
        },
        invoiceNumber: {
          value: this.props.item.invoiceNumber,
          valid: true,
        }
      },
      recaptchaToken: null,
      vendorId: null,
      infoForm: {
        success: false,
        error: false,
      },
    }
  },
  computed: {
    ...mapState('lk/competencies', {
      legalInfo: state => state.legalInfo
    }),
    isFormValid () {
      return Object.values(this.form).every(field => {
        if (this.hasFieldCheck(field)) return field.valid
        return true
      });
    },
    formatedDate () {
      if (!this.form.date.value) return '';
      const [dd, mm, yyyy] = this.form.date.value.split('-');
      return `${yyyy}.${mm}.${dd}`;
    }
  },
  methods: {
    ...mapActions('modal', [
        'modalClose'
    ]),
    ...mapActions('lk/leads', {
      lk_changeStatus: 'changeStatus',
    }),
    handleChangeAmount (e) {
      this.form.amount.valid = true;
      e.target.value = e.target.value.replace(/(^0+|\D+)/, "");

      if (!e.target.value) {
        this.form.amount.valid = false;
      }

      this.form.amount.value = e.target.value;
    },
    focusoutInvoiceNumber (e) {
      if (this.form.invoiceNumber.value === this.invoiceFieldPrefix) {
        e.target.value = ''
        this.form.invoiceNumber.value = null
      }
    },
    handleChangeInvoiceNumber (e) {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 9)

      const masked = `${this.invoiceFieldPrefix}${digits}`

      e.target.value = masked

      this.form.invoiceNumber.value = masked
      this.form.invoiceNumber.valid = this.checkInvoiceNumber()
    },
    checkInvoiceNumber() {
      if (!this.form.invoiceNumber.value) return true
      const digits = this.form.invoiceNumber.value.replace(/\D/g, "").slice(0, 9)
      return this.form.invoiceNumber.valid = digits.length === 9 || digits.length === 0
    },
    handleChangeDate ({ date }) {
      this.form.date.valid = true;
      this.form.date.value = date;
    },
    onCapchaRegister(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      if (this.isFormValid) this.sendForm();
    },
    handleSubmitClick (e) {
      e.preventDefault();
      e.stopPropagation();
      this.validate();

      if (!this.isFormValid) return;


      const isProd = process.env.NODE_ENV === 'production'

      if (!isProd) {
        this.sendForm();
        return;
      }

      this.$refs.recaptcha.execute();
    },
    hasFieldCheck(field) {
      return Object.hasOwn(field, 'valid')
    },
    handleRefuseClick (e) {
      e.preventDefault();
      e.stopPropagation();
      this.modalClose();
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset();
    },
    errorCaptcha () {
      console.log('errorCaptcha');
    },
    validate () {
      this.form.date.valid = !!this.form.date.value
      this.form.amount.valid = !!this.form.amount.value
      this.form.invoiceNumber.valid = this.checkInvoiceNumber()
    },
    async sendForm() {
      await this.lk_changeStatus({
        id: this.props.item.id,
        status: 2, // статус ВЫИГРАЛ, вынести статус в отдельный файл,
        date: this.form.date.value,
        amount: this.form.amount.value,
        invoiceNumber: this.form.invoiceNumber.value ?? ''
      })

      await this.props.winLeadHandler?.()
    }
  }
}
</script>


<style lang="sass">
.t-lk-win-lead-modal
  max-width: 500px

  &__form
    margin-block-start: 36px
    display: flex
    flex-direction: column
    gap: 24px

  &__field
    position: relative
    display: flex
    flex-direction: row
    gap: 16px

  &__input.t-input
    padding-inline-start: 36px

  &__date.t-lk-date-input__container
    position: absolute
    inset: 0

    & .t-lk-date-input
      padding-inline-start: 8px
      height: 100%
      width: 100%
      display: flex
      align-items: center

  &__field-icon
    font-size: 24px
    font-weight: 700
    position: absolute
    inset-block: 0
    inset-inline-start: 16px
    display: flex
    align-items: center
    color: #00b0bd

  &__controls
    margin-block-start: 12px
    display: flex
    flex-direction: row
    gap: 24px
    justify-content: flex-end
</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/win-lead-modal.vue